import React from 'react'
import './Works.css'
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import Amazon from "../../img/amazon.png";
import { themeContext } from '../../Context'
import { useContext } from 'react'
import {motion} from 'framer-motion'

const Works = () => {

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    const transition = {duration : 2, type : 'spring'}

    return (
        <div className="works" id="Experience">
            {/* left side */}
            <div className="awesome">
                <span style={{color: darkMode? 'white': ''}}>Works for All these</span>
                <span>Brand & Clients</span>
                <span style={{color: darkMode? 'white': ''}}>
                    Motivated web developer looking for a role as web developer.
                    <br />
                    Passionate about building amazing applications.
                </span>
                <a href="mailto:divakarkumarchy2001@gmail.com">
                <button className="button s-button">Hire Me</button>
                </a>
                <div className="blur s-blur1"></div>
            </div>

            {/* Right side */}
            <div className="n-right" >
            <motion.div
            
            initial={{rotate : 360}}
            whileInView = {{rotate :-360}}
            viewport ={{margin:'-40px'}}
            transition={{duration : 25, type: 'spring'}}
                
                className="n-mainCircle">
                    <div className="n-secCircle">
                        <img src={Upwork} alt=""/>
                    </div>
                    <div className="n-secCircle">
                        <img src={Fiverr} alt=""/>
                    </div>
                    <div className="n-secCircle">
                        <img src={Amazon} alt=""/>
                    </div>
                    <div className="n-secCircle">
                        <img src={Shopify} alt=""/>
                    </div>
                    <div className="n-secCircle">
                        <img src={Facebook} alt=""/>
                    </div>
                    
                </motion.div>

                {/* Background Circle */}
                <div className="n-backCircle blueCircle" style={{background: darkMode? '#194988': '#194988'}}></div>
                <div className="n-backCircle yellowCircle"></div>
            </div>
            
        </div>
    )
}

export default Works


